import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // We only need to listen on click event because enter keypress triggers it too.
    const existingAction = this.element.dataset.action || "";
    this.element.dataset.action =
      `${existingAction} click->disable-click#disable`.trim();
  }

  disable(event) {
    event.preventDefault();
  }
}
